import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import Footer from '../components/layout/footer/footer'
import CookieBanner from '../components/ui/CookieBanner'
import GridOrbs from '../components/ui/GridOrbs'
import { HandleTracking } from '../helpers/handleTracking'

declare global {
    interface Window {
        dataLayer: any
    }
}

function Main() {
    HandleTracking()

    return (
        <div className="main">
            {/* Lights gliding along the page's background grid */}
            <GridOrbs />
            <Outlet />
            <Footer />
            <CookieBanner />
        </div>
    )
}

export default Main
